module.exports = __webpack_public_path__ + "static/media/facebook-square-brands.943fb15d.svg";